/**
 * Created by juanramos on 7/6/17.
 */
 import {ChangeDetectorRef, ViewChild} from '@angular/core';
 import {Injectable} from '@angular/core';
 import {BehaviorSubject} from "rxjs";
 
 import {ReturnStatement} from "@angular/compiler";
  
 declare var window: any;

 @Injectable()
 export class NotificationsService {
     public badgeNumber: BehaviorSubject<any> = new BehaviorSubject(0);
     public notificationTaped: BehaviorSubject<any> = new BehaviorSubject(false);
     constructor() {
     }
     public onNotificationReceived() {
         (<any>window).FirebasePlugin.onMessageReceived((message) => {
             try {
                 console.log(message);
                 if (message.tap) {
                     this.setNotificationTaped();
                 } else {
                     
                 }
             } catch (error) {
                 console.log(error);
             }
         });
     }
     public setBadgeNumber(badge: number) {
         this.badgeNumber.next(badge);
         
         console.log(this.badgeNumber.value);
     }
     public getBadgeNumber() {
         return this.badgeNumber.asObservable();
     }
     public unsubscribeObservable() {
         return this.badgeNumber.unsubscribe()
     }
     public resetBadge() {
         this.badgeNumber.next(0);
        
     }
     public getNavigationTapedNav() {
         return this.notificationTaped.asObservable();
     }
     public setNotificationTaped() {
         this.notificationTaped.next(true);
     }
     public resetNotificationTaped() {
         this.notificationTaped.next(false);
     }
     public increaseNotification(){
         
     }
 }
 


// WEBPACK FOOTER //
// ./src/services/notifications.service.ts